:host {
  display: block;
}

.o2-tabs {
}

.o2-tabs__navigation {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  background: var(--o2-blue-action-light, #{$blue-action-light});
}

.o2-tabs.type--underline {
  .o2-tabs__navigation {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    background: none;
    justify-content: start;
    border-bottom: 0.1rem solid var(--o2-gray-light, #{$gray-light});
  }
}

::slotted(o2-swiper) {
  width: 100%;
  margin-bottom: 0 !important;
}
